import React from 'react';
import { isEditorActive } from '@sitecore-jss/sitecore-jss-react';
import { isEmptyResponse } from '../../utils/checkEmptyResponse';
import EmptyApiDataMessage from '../@shared/emptyApiDataMessage';
import useExperienceEditorPlaceholder from '../../hooks/useExperienceEditorPlaceholder';
import ExperienceEditorComponentPlaceholder from '../@shared/experienceEditorComponentPlaceholder';
import ProductSpecialOffers from '../productSpecialOffers';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import AnalyticsVisibleEvent from '../@shared/analyticsVisibleEvent';
import { lineSpecialOffersVisible } from '../../constants/analytics.constants';
import {
  descriptionKeyLineSpeicalOffers,
  eyebrowKeyLineSpeicalOffers,
  titleKeyLineSpeicalOffers,
} from '../../constants/dictionary.constants';
import './index.scss';

const ProductLineSpecialOffers = (props) => {
  const apiResponse = isEmptyResponse(props);
  const isPlaceholderShown = useExperienceEditorPlaceholder(props);
  const hasItems = props?.fields?.apiData?.items && props?.fields?.apiData?.items?.length > 0 

  // Component is unreleased
  if (props?.fields?.isComponentUnreleased) {
    return <UnreleasedComponent />;
  }

  //  star node opened directly in EE
  if (isPlaceholderShown) {
    return (
      <ExperienceEditorComponentPlaceholder image={props?.fields?.itemData?.thumbnail} componentName={props?.rendering?.componentName} />
    );
  }

  // not opened from star node
  // data missing when navigating via from products node
  if (!apiResponse && isEditorActive()) {
    return <EmptyApiDataMessage componentName={props?.rendering?.componentName} />;
  }

  // No data and not in EE
  if (!apiResponse && !isPlaceholderShown && !isEditorActive()) {
    return null;
  }

  return (
    <AnalyticsVisibleEvent sendEvent={hasItems} event={lineSpecialOffersVisible}>
      <div className="product-listing-special-offers">
        <ProductSpecialOffers
          {...props}
          eyebrowKeySpeicalOffers={eyebrowKeyLineSpeicalOffers}
          titleKeySpeicalOffers={titleKeyLineSpeicalOffers}
          descriptionKeySpeicalOffers={descriptionKeyLineSpeicalOffers}
        />
      </div>
    </AnalyticsVisibleEvent>
  );
};

export default ProductLineSpecialOffers;
